import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { queryClient } from '@/lib/queryClient';
import { useGlobalResumePolling } from '@/hooks/useGlobalResumePolling';
import LoginPage from '@/pages/Login';
import SignupPage from '@/pages/Signup';
import SignupCompletePage from '@/pages/SignupComplete';
import CapabilitiesPage from '@/pages/Capabilities';
import PostingsPage from '@/pages/Postings';
import ResumesPage from '@/pages/Resumes';
import ResumeViewPage from '@/pages/ResumeView';
import ResumeBuilderPage from '@/pages/ResumeBuilder';
import SettingsPage from '@/pages/Settings';
import AdminPage from '@/pages/Admin';
import LandingPage from '@/pages/Landing';
import ApplicationsPage from '@/pages/Applications';

function AppRoutes() {
  // Enable global resume polling across all pages
  useGlobalResumePolling();

  return (
    <Routes>
      {/* Marketing */}
      <Route path="/" element={<LandingPage />} />

      {/* Public routes */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/signup" element={<SignupPage />} />
      <Route path="/signup/complete" element={<SignupCompletePage />} />

      {/* Protected routes (auth check is in the component for now; P1 will add a guard) */}
      <Route path="/capabilities" element={<CapabilitiesPage />} />
      <Route path="/postings" element={<PostingsPage />} />
      <Route path="/postings/:postingId/build" element={<ResumeBuilderPage />} />
      <Route path="/resumes" element={<ResumesPage />} />
      <Route path="/resumes/:id" element={<ResumeViewPage />} />
      <Route path="/settings" element={<SettingsPage />} />
      <Route path="/admin" element={<AdminPage />} />
      <Route path="/applications" element={<ApplicationsPage />} />

      {/* Fallback */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}
